import { atom } from 'jotai'

export interface FiltersType {
  search: string
  ou: string[]
  year: string[]
  entry: 'all' | 'shortlist' | 'winner' | 'braveBoundless' | 'nominee'
  category: string[]
}

export const filtersAtom = atom<FiltersType>({
  search: '',
  ou: [],
  year: ['2025'],
  entry: 'all',
  category: [],
})
